import { GRADE_LEVELS_K12 } from '../../../constants/grades';
import { GraphData } from '../../../Types/graph';

export interface AnswerObject {
  text: string;
}

export type VisualizationType =
  | 'none'
  | 'rectangular_prism'
  | 'cube'
  | 'sphere'
  | 'cylinder'
  | 'cone'
  | 'pyramid'
  | 'triangular_prism'
  | 'hemisphere'
  | 'square'
  | 'rectangle'
  | 'triangle'
  | 'cube2d'
  | 'polygon'
  | 'circle'
  | 'fraction_rectangle'
  | 'fraction_circle'
  | 'bar_chart'
  | 'line_chart'
  | 'pie_chart'
  | 'scatter_plot'
  | 'histogram'
  | 'area_chart'
  | 'coordinate_plane'
  | 'number_line'
  | 'generic_3d'
  | 'generic_2d';

export interface Question {
  question: string;
  answers: Array<string | AnswerObject>;
  correctAnswer: string;
  explanation?: string;
  bloomsLevel?: string;
  standardReference?: string;
  answerType?: string;
  graph?: GraphData;
  visualizationType?: VisualizationType;
  is3D?: boolean;
  useCustomRenderer?: boolean;
  dimensions?: Record<string, number>;
}

export function isAnswerObject(answer: string | AnswerObject): answer is AnswerObject {
  return typeof answer === 'object' && answer !== null && 'text' in answer;
}

export interface Standard {
  _id: string;
  code?: string;
  standard: string;
  description: string;
  strand?: string;
  gradeLevel?: string;
  short_description?: string;
  teachingStandard?: string;
  teachingStandardName?: string;
}

export interface MathWordProblemData {
  questions: Question[];
  gradeLevel: string;
  standards: Standard[];
}

export interface MathWordProblemResponse {
  questions: Question[];
  answerKey?: string;
  _id?: string;
}

export type GradeLevel = 'K' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12';
export const GRADE_LEVELS: GradeLevel[] = [...GRADE_LEVELS_K12];
